<template>
  <v-expansion-panel
    v-model="expansionPanel"
    class="v-expansion-panel_inlined"
  >
    <v-expansion-panel-content>
      <template slot="header">
        <v-layout align-center>
          <baseIcon
            v-if="false"
            :width="36"
            :height="36"
            class="mr-3"
          />
          {{ $t('warehouses.family_list') }}
        </v-layout>
      </template>
      <v-card class="mb-0 pb-1">
        <v-divider />
        <v-layout
          class="mt-4 align-stretch volunteers"
          wrap
        >
          <v-flex
            md3
            xs12
          >
            <h3 class="d-inline-block f-2 sz_dark_grey--text mb-1">
              {{ $t('warehouses.families') }} <span>{{ familiesAmount | brackets }}</span>
            </h3>
          </v-flex>
          <v-flex xs12>
            <v-data-table
              :headers="headers"
              :items="families"
              :loading="isLoading"
              hide-actions
              item-key="family_edition_id"
            >
              <template
                slot="headers"
                slot-scope="props"
              >
                <tr>
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    class="text-xs-left"
                  >
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template
                slot="items"
                slot-scope="props"
              >
                <tr>
                  <td>{{ props.item.family_code }}</td>

                  <td
                    :class="[
                      { 'fw-600': $vuetify.breakpoint.smAndUp },
                      { 'py-1 pr-0': $vuetify.breakpoint.xsOnly }
                    ]"
                  >
                    {{ fullName(props.item) }}
                  </td>
                  <td>
                    <p class="ma-0">
                      {{ fullStreet(props.item) }}
                    </p>
                    <p class="ma-0">
                      {{ fullCity(props.item) }}
                    </p>
                  </td>
                  <td>
                    <p class="mb-0">
                      {{ $t('list.primary') }}:
                      {{
                        volunteerName(props.item.primary_volunteer)
                          ? volunteerName(props.item.primary_volunteer)
                          : $t('list.none')
                      }}
                    </p>
                    <p class="mb-0">
                      {{ $t('list.secondary') }}:
                      {{
                        volunteerName(props.item.secondary_volunteer)
                          ? volunteerName(props.item.secondary_volunteer)
                          : $t('list.none')
                      }}
                    </p>
                  </td>
                  <td class="pl-1">
                    <familyStatus
                      :mobile="$vuetify.breakpoint.xs"
                      :status="props.item.status"
                    />
                  </td>
                </tr>
              </template>
              <template slot="no-data">
                <tr>
                  <td colspan="9">
                    <p class="text-xs-center pt-3">
                      {{ $t('message.error_families_list_empty') }}
                    </p>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <BasePagination
              class="mb-0"
              :pagination="pagination"
              :per-page="perPage"
              :amount-all="pagination.amountAll"
              @page="setPage($event)"
              @amount="setItemsPerPage($event)"
            />
          </v-flex>
        </v-layout>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import baseIcon from '@/icons/BaseIcon';
import filters from '@/constants/filters';
import FamilyStatus from '@/components/widgets/dataTable/FamilyStatus';
import BasePagination from '@/components/widgets/dataTable/BasePagination';
export default {
    name: 'WarehouseFamilyList',
    components: { BasePagination, FamilyStatus, baseIcon },
    filters: {
        ...filters
    },
    props: {
        warehouseId: {
            required: true
        }
    },
    data () {
        return {
            expansionPanel: 0,
            isLoading: false,
            pagination: { page: 1, amount: 20, amountAll: 0 },
            headers: [
                { text: this.$t('label.family_code') },
                { text: this.$t('label.family') },
                { text: this.$t('label.address') },
                { text: this.$t('label.volunteers') },
                { text: this.$t('label.status') }
            ],
            perPage: [{ amount: 20 }, { amount: 50 }]
        };
    },
    computed: {
        xsOnly () {
            return this.$vuetify.breakpoint.xsOnly;
        },
        families () {
            return this.$store.getters['warehouse/getFamiliesInWarehouse'];
        },
        familiesAmount () {
            return this.$store.getters['warehouse/getFamiliesInWarehouseAmount'];
        }
    },
    watch: {
        familiesAmount: {
            handler (val) {
                this.pagination.amountAll = val;
            },
            immediate: true
        }
    },
    methods: {
        fullName (item) {
            if (item === null) return null;
            const _firstName = item.first_name != null ? item.first_name : '';
            const lastName = item.last_name != null ? item.last_name : '';
            return _firstName + ' ' + lastName;
        },
        volunteerName (item) {
            if (item == null) return null;
            return item.full_name;
        },
        fullStreet (item) {
            const street = item.street ? item.street : '';
            const _flat = item.flat_number !== null ? '/' + item.flat_number : '';
            return street + ' ' + item.building_number + _flat;
        },
        fullCity (item) {
            return this.$options.filters.postalCode(item.postal_code) + ' ' + item.city;
        },
        setPage (event) {
            this.pagination.page = event;
            this.getFamilies();
        },
        setItemsPerPage (event) {
            this.pagination.amount = event;
            this.pagination.page = 1;
            this.getFamilies();
        },
        getFamilies () {
            this.isLoading = true;
            const params = new URLSearchParams();
            params.append('limit', this.pagination.amount);
            const _offestNum = (this.pagination.page - 1) * this.pagination.amount;
            params.append('offset', _offestNum);
            const data = {
                warehouseId: this.warehouseId,
                params
            };
            this.$store.dispatch('warehouse/getFamiliesPerWarehouse', data).finally(() => {
                this.isLoading = false;
            });
        }
    }
};
</script>

<style scoped></style>
